import { post, get } from "../axios/index.js"
// 修改用户信息(时区)
export const userChangeUserInfo = async (parmas) => {
  const res = await post('/user/changeUserInfo', parmas)
  return res || {}
}
// 修改用户新老版本
export const userSwitchNew = async (parmas) => {
  const res = await post('/user/switchNew', parmas)
  return res || {}
}
// 退出登录
export const userLogout1 = async (parmas) => {
  const res = await post('/user/logout1', parmas)
  return res || {}
}
